import script from "./StableTokenPill.vue?vue&type=script&setup=true&lang=ts"
export * from "./StableTokenPill.vue?vue&type=script&setup=true&lang=ts"

import "./StableTokenPill.vue?vue&type=style&index=0&id=0db67c42&scoped=true&lang=css"

import exportComponent from "/Users/jason/u/acsi-ui-balancer-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0db67c42"]])

export default __exports__